const styles = (theme) => ({
  containerPaper: {
    backgroundColor: theme.palette.background.paper,
    padding: "20px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
  },
  containerActions: {
    width: "100%",
    margin: "20px 0",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
  },
  boxDatagrid: {
    height: "300px",
  },
  boxComponent: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: 2,
  },
});

export default styles;
